import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { SelectLookupControl } from "@/Common/Components/Inputs/SelectLookupControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LifeStageModeEnum } from "@/Patient/Models/LifeStageModeEnum";

interface ILifeStageModeProps {
    lifeStageSelectedLifeStageLookupId: string;
    lifeStageAvailableLifeStages: FlatLookupView[];
    useThreeCols: boolean;
    onLifeStageModeClick: (newMode: LifeStageModeEnum) => void;
    onLifeStageChange: (value: string) => void;
}

function LifeStageMode(props: ILifeStageModeProps): JSX.Element {
    const { getText } = useTranslation();
    const renderLifeStageModeButtons = (): JSX.Element => (
        <>
            <a className="pointer" onClick={() => props.onLifeStageModeClick(LifeStageModeEnum.Age)}>
                <span>
                    {getText("AgeAtOnsetLabel")}
                </span>
            </a>
            {" | "}
            <a className="pointer" onClick={() => props.onLifeStageModeClick(LifeStageModeEnum.Date)}>
                <span>
                    {getText("StartDateLabel")}
                </span>
            </a>
        </>
    );
    return (
        <tr key="lifesstage">
            <td className="c1">
                <span>{getText("LifeStageDLabel")}</span>
            </td>
            <td className="c2">
                <SelectLookupControl
                    dataCy="medicalItems-medicalReaction-lifeStage"
                    IncludeEmptyChoice={true}
                    Value={props.lifeStageSelectedLifeStageLookupId}
                    AvailableValues={props.lifeStageAvailableLifeStages?.map(x => x.ToComboboxItem()) ?? []}
                    Callback={value => props.onLifeStageChange(value)}
                />
            </td>
            {props.useThreeCols && (
                <td className="c3" colSpan={2}>
                    {renderLifeStageModeButtons()}
                </td>
            )}
            {!props.useThreeCols && (
                <>
                    <td className="c3" />
                    <td className="c4" data-cy="medicalItems-medicalReaction-lifeStage-modes">
                        {renderLifeStageModeButtons()}
                    </td>
                </>
            )}
        </tr>
    );
}

export { LifeStageMode };
